module.exports = __webpack_public_path__ + "img/readNow-success.e0312c17.png";